import type { MenusEmpresaDto } from '@triade/contracts';
import { useSessao } from '@/lib/session';
import { useMutacao } from './base';
import { useEmpresas } from './me';

/**
 * Itens do menu desligados para a empresa escolhida (Configuracoes > Empresa > Menus), lidos de GET /me/empresas. So exibicao.
 * `undefined` enquanto carrega ou sem empresa: quem recebe trata como "tudo ligado".
 */
export function useMenusDesligadosDaEmpresa(): string[] | undefined {
  const { empresaId } = useSessao();
  const empresas = useEmpresas();
  if (empresaId === null || !empresas.data) return undefined;
  return empresas.data.find((e) => e.id === empresaId)?.menusDesligados;
}

/** PUT /empresa/menus (403 sem empresas.gerenciar). Invalida /me/empresas para o menu, a busca e os favoritos refletirem. */
export function useSalvarMenus() {
  return useMutacao<MenusEmpresaDto, MenusEmpresaDto>({
    metodo: 'PUT',
    caminho: () => '/empresa/menus',
    corpo: (dto) => dto,
    invalidar: [['me', 'empresas']],
  });
}
